import React from 'react';
import { InlineEditor } from 'components';

function StringEditor({ ...props }) {
  return <InlineEditor.Input {...props} />;
}

export default StringEditor;
